import { Nullable } from '@clearverify/types';

export enum ResetPasswordFormFields {
  newPassword = 'newPassword',
  confirmNewPassword = 'confirmNewPassword',
}

export type ResetPasswordFormValues = {
  [ResetPasswordFormFields.newPassword]: Nullable<string>;
  [ResetPasswordFormFields.confirmNewPassword]: Nullable<string>;
};
